import { useTranslation } from 'react-i18next'

import { HTML_LINK_TARGET } from '../../../constants/html'
import { useUk } from '../../../hooks'
import { Link } from '../../Link'
import { GDPR_LINK, TERMS_AND_CONDITIONS_LINK } from '../Auth.constants'

import * as styles from './AuthLicense.module.css'

function AuthLicense({
  className = styles.AuthLicense,
  text = 'Auth.TermsAndConditionsTextKey',
}) {
  const { t } = useTranslation()

  const { config: ukConfig } = useUk()

  return (
    <p className={className}>
      <span>{t(text)} </span>
      <Link
        rel='noopener noreferrer'
        target={HTML_LINK_TARGET.blank}
        to={TERMS_AND_CONDITIONS_LINK}
      >
        {t('Auth.TermsAndConditionsLinkKey')}
      </Link>
      <span> {t('Auth.TermsAndConditionsJointKey')} </span>
      <Link
        rel='noopener noreferrer'
        target={HTML_LINK_TARGET.blank}
        to={ukConfig?.gdpr || GDPR_LINK}
      >
        {t('Auth.GdprLinkKey')}
      </Link>
    </p>
  )
}

export default AuthLicense
